// src/services/api.js
import axios from 'axios';
import authService from './authService';

const API_URL = 'https://kortex.phone.gs/vtigercrm/moncrm/agendaEspagne/api';

export const getRdv = async () => {
  const token = authService.getToken();
  const response = await axios.get(`${API_URL}/getRdv.php`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  
  let rdvData = response.data;
  
  // Récupérer l'utilisateur connecté
  const user = authService.getUser();
  
  // Si la filiale de l'utilisateur n'est pas "ALL", filtrer les données
  if (user && user.filiale && user.filiale !== "ALL") {
    rdvData = rdvData.filter(rdv => rdv.filiale === user.filiale);
  }
  
  return rdvData;
};
